module.exports = __webpack_public_path__ + "static/media/ico-restapi.acc81f23.svg";